import React, {Component} from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';
import Logo from './Logo';
import Nav from './Nav';
import Social from './Social';
import About from './About';

const HeaderBlock = styled.header`

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: 1fr 3fr 1.5fr;
  }
`;

export default class Header extends Component {
  render(){
    return (
      <HeaderBlock>
        <Logo />
        <Nav />
        <Social />
        <About />
      </HeaderBlock>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js